import { render, staticRenderFns } from "./teaminfo.vue?vue&type=template&id=3a86511b&scoped=true"
import script from "./teaminfo.vue?vue&type=script&lang=js"
export * from "./teaminfo.vue?vue&type=script&lang=js"
import style0 from "./teaminfo.vue?vue&type=style&index=0&id=3a86511b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86511b",
  null
  
)

export default component.exports